import { PlaybackTypes } from 'store/railsBuilder/reducer.types';

export const isAssetVod = (playbackType: PlaybackTypes | undefined) => {
    return playbackType === PlaybackTypes.vod_ed;
};
